module.exports = __webpack_public_path__ + "images/3fad0f2b495a46da044b96f6c3d05d4b.png";